/**
 * @packageDocumentation
 * @module DaVinci_API
 */

/** Represents an audio input or output device available on the system. */
export interface IAudioDevice {
  deviceId: string;
  name: string;
  isSystemDefault?: boolean;
}

export type AudioDirection = 'input' | 'output';

/** State for one independently selectable audio direction. */
export interface IAudioDirectionState {
  devices: IAudioDevice[];
  /** Whether the platform supports choosing a device for this direction. */
  selectionAvailable: boolean;
  /** Last device preference committed by the user; null means follow system default. */
  preferredDeviceId: string | null;
  /** Device currently applied by the audio provider. */
  actualDeviceId: string | null;
}

/** Complete input/output audio state published by an audio provider. */
export interface IAudioState {
  input: IAudioDirectionState;
  output: IAudioDirectionState;
}

/** A request to apply or reset a device for one direction. */
export interface IAudioDeviceSelection {
  direction: AudioDirection;
  /** null requests the system default for this direction. */
  deviceId: string | null;
}

/** A directional selection operation routed to the audio provider. */
export interface IAudioDeviceOperation extends IAudioDeviceSelection {
  action: 'apply' | 'save';
}
